<template>
  <div style="margin: 10px">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <!-- <h4>筛选查询</h4> -->
          <el-row>
            <el-col :span="20">
              <el-form
                :inline="true"
                :model="form"
                class="demo-form-inline"
                size="mini"
              >
                <el-form-item label="标题">
                  <el-input v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getData">查询</el-button>
                  <el-button type="danger" @click="clear">清空</el-button>
                </el-form-item>
                <el-form-item>
                  <button class="addAll" @click="update('add')">
                    新增商品
                  </button>
                </el-form-item>
                <el-form-item>
                  <button
                    class="addAll"
                    @click="
                      $router.push({
                        path: '/home/parameters',
                        query: {
                          id: $route.query.id,
                        },
                      })
                    "
                  >
                    商品参数管理
                  </button>
                </el-form-item>
                <el-form-item>
                  <el-button type="info">导出</el-button>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="2"></el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-table
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                size="mini"
                ref="multipleTable"
                :data="tableData"
                style="width: 100%"
                border
                :header-cell-style="{ background: '#E5E7EE', color: '#000000' }"
                row-key="id"
              >
                <el-table-column type="selection" width="55" align="center">
                </el-table-column>
                <el-table-column
                  align="left"
                  :prop="dropCol[index].prop"
                  :label="item.label"
                  v-for="(item, index) in col"
                  :key="`col_${index}`"
                  :width="index == 0 ? '55' : ''"
                >
                </el-table-column>
                <el-table-column prop="roof" label="置顶" align="center">
                  <template slot-scope="scope">
                    <el-switch
                      @change="updateTop(scope.$index, scope.row)"
                      v-model="scope.row.roof"
                      :active-value="0"
                      :inactive-value="1"
                      active-color="#13ce66"
                      inactive-color="#dcdfe6"
                    >
                    </el-switch>
                  </template>
                </el-table-column>
                <el-table-column prop="status" label="商品状态" align="center">
                  <template slot-scope="scope">
                    <el-switch
                      @change="updateStatus(scope.$index, scope.row)"
                      :active-value="0"
                      :inactive-value="1"
                      v-model="scope.row.status"
                      active-color="#13ce66"
                      inactive-color="#dcdfe6"
                    >
                    </el-switch>
                  </template>
                </el-table-column>

                <el-table-column prop="addTime" label="更新时间" align="center">
                </el-table-column>

                <el-table-column fixed="right" label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="success"
                      icon="el-icon-edit"
                      circle
                      size="small"
                      @click.native.prevent="update('update', scope.row)"
                    ></el-button>
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      circle
                      @click.native.prevent="deleteRow(scope.$index, scope.row)"
                      size="small"
                    ></el-button>
                    <!-- 这个是添加箭头 -->
                    <div class="tops">
                      <i
                        class="el-icon-caret-top"
                        @click="moves(scope.row.id, 0)"
                      ></i>
                      <i
                        class="el-icon-caret-bottom"
                        @click="moves(scope.row.id, 1)"
                      ></i>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="tableFooter">
                <button class="selectAll" @click="toggleSelection(tableData)">
                  全选
                </button>
                <button class="del" @click="batDel">批量删除</button>
              </div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20]"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="total"
              >
              </el-pagination>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '../../../assets/js/request.js'
import qs from 'qs'
export default {
  data () {
    return {
      form: {
        one: '',
        two: '',
        three: '',
        title: ''
      },
      listOne: [],
      listTwo: [],
      listThree: [],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      multipleTable: [],
      loading: false,
      twoShow: false,
      threeShow: false,
      col: [{
        label: '编号',
        prop: 'id'
      },
      {
        label: '商品名称',
        prop: 'goodsName'
      }
      ],
      dropCol: [{
        label: '编号',
        prop: 'id'
      },
      {
        label: '商品名称',
        prop: 'goodsName'
      }

      ]
    }
  },
  watch: {
    '$route.query': {
      handler (query) {
        let path = this.$route.path
        this.loading = true
        this.getData(this.currentPage, this.pageSize)
      }
    }

  },
  created () {
    this.getData(this.currentPage, this.pageSize)
    // this.getType()
  },
  mounted () {
    this.rowDrop()
  },
  methods: {
    async moves (id, index) {
      const res = await this.$http({
        method: 'get',
        url: '/api/v2/goods/change/order',
        params: {
          id: id,
          type: index
        }
      })
      console.log('点击排序', res)
      if (res.data.status === 200) {
        this.getData(this.currentPage, this.pageSize)
      } else {
        this.$message.error(res.data.message)
      }
    },
    // 行拖拽
    rowDrop () {
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      const _this = this
      this.Sortable.create(tbody, {
        onEnd ({
          newIndex,
          oldIndex
        }) {
          const currRow = _this.tableData.splice(oldIndex, 1)[0]
          _this.tableData.splice(newIndex, 0, currRow)
        }
      })
    },
    clear () {
      this.form.title = ''
      this.getData(this.currentPage, this.pageSize)
    },
    // 获取列表数据
    getData (currentPage, pageSize) {
      this.loading = true
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v2/goods/page',
        params: {
          cid: this.$route.query.id,
          roof: '',
          title: this.form.title,
          status: '',
          pageNum: currentPage,
          pageSize: pageSize
        }
      }).then((res) => {
        if (res.data.status == 200) {
          this.loading = false
          this.tableData = res.data.data.data
          this.total = res.data.data.total
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    // 获取分类
    getType () {
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v1/goods/column/one',
        params: {

        }
      }).then((res) => {
        if (res.data.status == 200) {
          this.listOne = res.data.data
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    getOne (event) {
      this.twoShow = true
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v1/goods/column/child',
        params: {

          id: event
        }
      }).then((res) => {
        if (res.data.status == 200) {
          this.listTwo = res.data.data
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    getTwo (event) {
      this.threeShow = true
      this.form.three = ''
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v1/goods/column/child',
        params: {

          id: event
        }
      }).then((res) => {
        if (res.data.status == 200) {
          this.listThree = res.data.data
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    // 分页事件
    handleSizeChange (val) {
      this.pageSize = val // 将每页显示的条数 = 改变的值
      this.getData(this.currentPage, this.pageSize)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getData(this.currentPage, this.pageSize)
    },
    // 修改
    update (iden, rows) {
      if (iden == 'add') {
        this.$router.push({
          path: '/home/productUpdate',
          query: {
            iden: iden,
            id: this.$route.query.id
          }
        })
      } else {
        this.$router.push({
          path: '/home/productUpdate',
          query: {
            iden: iden,
            rows: rows,
            id: this.$route.query.id,
            productId: rows.id
          }
        })
      }
    },
    deleteRow (index, rows) {
      this.$confirm('此操作将永久删除所选信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.loading = true
        var obj = this
        obj.$http({
          method: 'get',
          url: 'api/v1/goods/delete',
          params: {
            id: rows.id,
            uid: localStorage.getItem('uid')
          }
        }).then((res) => {
          if (res.data.status == 200) {
            this.loading = false
            obj.$message.success('删除成功')
            this.getData(this.currentPage, this.pageSize)
          } else {
            obj.$message.error(res.data.message)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 批量删除
    batDel () {
      if (this.$refs.multipleTable.selection.length == 0) {
        this.$message.error('请选择要删除的表格信息！')
        return
      }
      var list = []
      for (var i = 0; i < this.$refs.multipleTable.selection.length; i++) {
        list.push(this.$refs.multipleTable.selection[i].id)
      }
      this.$confirm('此操作将永久删除所选信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.loading = true
        var obj = this
        obj.$http({
          method: 'get',
          url: 'api/v1/goods/clear',
          params: {
            ids: list.toString(),
            uid: localStorage.getItem('uid')
          }
        }).then((res) => {
          if (res.data.status == 200) {
            this.loading = false
            obj.$message.success('删除成功')
            this.getData(this.currentPage, this.pageSize)
          } else {
            obj.$message.error(res.data.message)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 全选
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    // 修改状态
    updateStatus (index, rows) {
      this.loading = true
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v1/goods/change/status',
        params: {
          id: rows.id,

          status: rows.status
        }
      }).then((res) => {
        if (res.data.status == 200) {
          this.loading = false
          obj.$message.success('修改成功')
          this.getData(this.currentPage, this.pageSize)
        } else {
          this.loading = false
          obj.$message.error(res.data.message)
        }
      })
    },
    // 修改置顶
    updateTop (index, rows) {
      this.loading = true
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v1/goods/change/roof',
        params: {
          id: rows.id,
          uid: localStorage.getItem('uid'),
          roof: rows.roof
        }
      }).then((res) => {
        if (res.data.status == 200) {
          this.loading = false
          obj.$message.success('修改成功')
          this.getData(this.currentPage, this.pageSize)
        } else {
          this.loading = false
          obj.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style scoped="scoped">
/deep/ .el-form-item__label {
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
}

/deep/ .el-button--text {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #7c96f8;
  line-height: 24px;
}

span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #7c96f8;
  line-height: 24px;
}

.chenggong {
  width: 49px;
  height: 16px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 24px;
  opacity: 0.7;
}

.fail {
  width: 33px;
  height: 16px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #76b67e;
  line-height: 24px;
}

h4 {
  margin-bottom: 20px;
}
.tops {
  display: inline-block;
  width: 40px;
  margin-left: 20px;
  vertical-align: middle;
}
.tops i {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/content/commodity/commodity.vue